import React from 'react';
import { useAppState } from '../../context/AppStateContext';

const ToastContainer = () => {
    const { toast, dispatch } = useAppState();

    if (!toast) return null;

    const isSuccess = toast.type === 'success';
    const isInfo = toast.type === 'info' || toast.type === 'loading';
    const isWarning = toast.type === 'warning';

    const getStyles = () => {
        if (isSuccess) return 'bg-emerald-50 border-emerald-100 text-emerald-800';
        if (isInfo) return 'bg-indigo-50 border-indigo-100 text-indigo-800';
        if (isWarning) return 'bg-amber-50 border-amber-100 text-amber-800';
        return 'bg-rose-50 border-rose-100 text-rose-800';
    };

    const getIcon = () => {
        if (isSuccess) return 'fa-check-circle text-emerald-500';
        if (isInfo) return 'fa-info-circle text-indigo-500';
        if (isWarning) return 'fa-exclamation-circle text-amber-500';
        return 'fa-exclamation-triangle text-rose-500';
    };

    const getTitle = () => {
        if (isSuccess) return 'Success!';
        if (isInfo) return 'Processing...';
        if (isWarning) return 'Warning';
        return 'Error';
    };

    return (
        <div className="fixed bottom-6 right-6 z-[99999] animate-slide-in-up">
            <div className={`flex items-center gap-3 px-6 py-4 rounded-2xl shadow-2xl border ${getStyles()}`}>
                <div className={`h-8 w-8 rounded-full flex items-center justify-center bg-white/50`}>
                    <i className={`fas ${getIcon()} text-sm`}></i>
                </div>
                <div>
                    <p className="font-bold text-sm tracking-tight">{getTitle()}</p>
                    <p className="text-xs opacity-80">{toast.message}</p>
                </div>
                <button
                    onClick={() => dispatch({ type: 'CLEAR_TOAST' })}
                    className="ml-4 hover:opacity-100 opacity-50 transition-opacity"
                >
                    <i className="fas fa-times text-xs"></i>
                </button>
            </div>
        </div>
    );
};

export default ToastContainer;
